import { cuverseApi } from 'store/api/cuverse-api/cuverse.api';

import { AffiliateRoute } from './affiliate.route';

export const requestReferralStats = async (): Promise<unknown> =>
  await cuverseApi.get(AffiliateRoute.ReferralStats()).then((res) => res?.data);

export const requestReferralLinks = async (): Promise<unknown> =>
  cuverseApi.get(AffiliateRoute.ReferralLinks()).then((res) => res?.data);

export const requestReferralHistory = async (): Promise<unknown> =>
  cuverseApi.get(AffiliateRoute.ReferralHistory()).then((res) => res?.data);
